import type { Icon } from '../../../src/lib/types'
export const mdiArrowULeftTop: Icon = {
  "id": "arrow-u-left-top",
  "name": "Arrow U Left Top",
  "path": "M20 13.5C20 17.09 17.09 20 13.5 20H6V18H13.5C16 18 18 16 18 13.5S16 9 13.5 9H7.83L10.91 12.09L9.5 13.5L4 8L9.5 2.5L10.92 3.91L7.83 7H13.5C17.09 7 20 9.91 20 13.5Z",
  "as": [
    "undo"
  ],
  "tags": []
}
export default mdiArrowULeftTop